/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EmergencyEmailContact } from './EmergencyEmailContact';
import {
    EmergencyEmailContactFromJSON,
    EmergencyEmailContactFromJSONTyped,
    EmergencyEmailContactToJSON,
    EmergencyEmailContactToJSONTyped,
} from './EmergencyEmailContact';

/**
 * 
 * @export
 * @interface GroupEmergencyContactsOnAzure
 */
export interface GroupEmergencyContactsOnAzure {
    /**
     * 
     * @type {string}
     * @memberof GroupEmergencyContactsOnAzure
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof GroupEmergencyContactsOnAzure
     */
    group_id: string;
    /**
     * 
     * @type {string}
     * @memberof GroupEmergencyContactsOnAzure
     */
    readonly object_type: string;
    /**
     * 
     * @type {string}
     * @memberof GroupEmergencyContactsOnAzure
     */
    readonly unique_key: string;
    /**
     * 
     * @type {string}
     * @memberof GroupEmergencyContactsOnAzure
     */
    readonly id: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof GroupEmergencyContactsOnAzure
     */
    contact_auth_ids: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: EmergencyEmailContact; }}
     * @memberof GroupEmergencyContactsOnAzure
     */
    contact_email_addresses: { [key: string]: EmergencyEmailContact; };
    /**
     * 
     * @type {boolean}
     * @memberof GroupEmergencyContactsOnAzure
     */
    add_new_members_to_emergency_contacts: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupEmergencyContactsOnAzure
     */
    _etag: string;
    /**
     * 
     * @type {number}
     * @memberof GroupEmergencyContactsOnAzure
     */
    _ts: number;
}

/**
 * Check if a given object implements the GroupEmergencyContactsOnAzure interface.
 */
export function instanceOfGroupEmergencyContactsOnAzure(value: object): value is GroupEmergencyContactsOnAzure {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('group_id' in value) || value['group_id'] === undefined) return false;
    if (!('object_type' in value) || value['object_type'] === undefined) return false;
    if (!('unique_key' in value) || value['unique_key'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('contact_auth_ids' in value) || value['contact_auth_ids'] === undefined) return false;
    if (!('contact_email_addresses' in value) || value['contact_email_addresses'] === undefined) return false;
    if (!('add_new_members_to_emergency_contacts' in value) || value['add_new_members_to_emergency_contacts'] === undefined) return false;
    if (!('_etag' in value) || value['_etag'] === undefined) return false;
    if (!('_ts' in value) || value['_ts'] === undefined) return false;
    return true;
}

export function GroupEmergencyContactsOnAzureFromJSON(json: any): GroupEmergencyContactsOnAzure {
    return GroupEmergencyContactsOnAzureFromJSONTyped(json, false);
}

export function GroupEmergencyContactsOnAzureFromJSONTyped(json: any, ignoreDiscriminator: boolean): GroupEmergencyContactsOnAzure {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'group_id': json['group_id'],
        'object_type': json['object_type'],
        'unique_key': json['unique_key'],
        'id': json['id'],
        'contact_auth_ids': json['contact_auth_ids'],
        'contact_email_addresses': (mapValues(json['contact_email_addresses'], EmergencyEmailContactFromJSON)),
        'add_new_members_to_emergency_contacts': json['add_new_members_to_emergency_contacts'],
        '_etag': json['_etag'],
        '_ts': json['_ts'],
    };
}

export function GroupEmergencyContactsOnAzureToJSON(json: any): GroupEmergencyContactsOnAzure {
    return GroupEmergencyContactsOnAzureToJSONTyped(json, false);
}

export function GroupEmergencyContactsOnAzureToJSONTyped(value?: Omit<GroupEmergencyContactsOnAzure, 'object_type'|'unique_key'|'id'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'group_id': value['group_id'],
        'contact_auth_ids': value['contact_auth_ids'],
        'contact_email_addresses': (mapValues(value['contact_email_addresses'], EmergencyEmailContactToJSON)),
        'add_new_members_to_emergency_contacts': value['add_new_members_to_emergency_contacts'],
        '_etag': value['_etag'],
        '_ts': value['_ts'],
    };
}

